import { normalizeAeroCode } from '../../../shared/aeroConnection.js';
const KEY = 'polka.telegram.connect.return';
const AERO_KEY = 'polka.aero.connect.return';
export function rememberAeroConnection(value) {
  try { sessionStorage.setItem(AERO_KEY, JSON.stringify({ code: normalizeAeroCode(value) || '', at: Date.now() })); } catch { /* Optional return path. */ }
}
export function rememberTelegramConnection() {
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* Login remains usable without storage. */ }
}
export function authDestination() {
  try {
    const aero = JSON.parse(sessionStorage.getItem(AERO_KEY));
    sessionStorage.removeItem(AERO_KEY);
    if (aero && Date.now() - aero.at >= 0 && Date.now() - aero.at < 10 * 60000) {
      const code = normalizeAeroCode(aero.code);
      return `/connect${code ? `?user_code=${encodeURIComponent(code)}` : ''}`;
    }
  } catch { /* Ignore invalid connection state. */ }
  try {
    const created = Number(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    if (created > 0 && Date.now() - created >= 0 && Date.now() - created < 10 * 60000) return '/settings?connect=telegram';
  } catch { /* Default destination. */ }
  return '/';
}
